(() => {
  const initialize = () => {
    document.querySelectorAll('form[data-adv-newsletter]').forEach((form) => {
      if (form.dataset.newsletterReady) return;
      form.dataset.newsletterReady = 'true';

      const email = form.querySelector('input[type="email"]');
      const button = form.querySelector('button[type="submit"]');
      const fields = form.querySelector('[data-newsletter-fields]');
      const success = form.querySelector('[data-newsletter-success]');
      const error = form.querySelector('[data-newsletter-error]');
      const listId = form.querySelector('input[name="g"]').value;
      let pending = false;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending || !form.reportValidity()) return;

        pending = true;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        error.hidden = true;
        email.removeAttribute('aria-invalid');
        email.setAttribute('aria-describedby', email.getAttribute('aria-describedby').replace(` ${error.id}`, ''));

        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(form.dataset.siteId)}`,
            {
              method: 'POST',
              headers: {
                accept: 'application/vnd.api+json',
                'content-type': 'application/vnd.api+json',
                revision: '2026-10-15',
              },
              credentials: 'omit',
              signal: controller.signal,
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: form.dataset.source,
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email.value.trim(),
                          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                        },
                      },
                    },
                  },
                  relationships: { list: { data: { type: 'list', id: listId } } },
                },
              }),
            },
          );

          if (response.status !== 202) throw new Error('Subscription request failed');
          fields.hidden = true;
          success.hidden = false;
          success.focus();
        } catch {
          error.textContent = form.dataset.errorMessage;
          error.hidden = false;
          email.setAttribute('aria-describedby', `${email.getAttribute('aria-describedby')} ${error.id}`);
        } finally {
          clearTimeout(timeout);
          pending = false;
          button.disabled = false;
          form.removeAttribute('aria-busy');
        }
      });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
